import { render, staticRenderFns } from "./RateCurrency.vue?vue&type=template&id=2ea83056&"
import script from "./RateCurrency.vue?vue&type=script&lang=ts&"
export * from "./RateCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports